// @flow
import React from 'react';
import { NumberUtil } from 'utils/NumberUtil';
import DotSeparator from 'components/atoms/dotSeparator';
import { EventTicketUserForm } from 'components/organisms/eventTicketUserForm';
import { useViewport } from 'components/templates/viewportProvider';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  onEditClick: () => void,
  data: Array<ticketDetails>,
};

type ticketDetails = {
  ticket_type: string,
  ticket_type_id: string,
  available_tickets?: number,
  price: number,
  selected: Array,
  total_cost: number,
};

const EventTicketCart = (props: Props) => {
  const { onEditClick, data, eventTimeID, onClosePress, eventTitle, eventDate, selectedFnBPackages, outletSeating, outlet_id } = props;
  const { isMobile } = useViewport();
  const getAmount = (amount) => {
    const total_amount = amount.toFixed(2);
    return NumberUtil.formatNumber(total_amount);
  }
  let cart_value =
     data.standing_tickets_data.total_cost +
     data.seating_tickets_data.total_cost;

  const renderSelectedFnBs = () => {
    if(!selectedFnBPackages || Object.keys(selectedFnBPackages).length === 0) {
      return null;
    }

    let fnb_total_cost = 0;
    fnb_total_cost = Object.values(selectedFnBPackages)
        .reduce((sum, pkg) => sum + (1.05 * pkg.price * pkg.quantity), 0);

    cart_value = cart_value + fnb_total_cost;

    return (
      <>
        {Object.values(selectedFnBPackages).map(pkg => (
        <div key={pkg.id} className={'ticket-info-container'}>
          <h3 className={'ticket-type-name'}>
            {pkg.name}
          </h3>
          <DotSeparator />
          <h3 className={'count'}>{pkg.quantity}</h3>
          <DotSeparator />
          <h3 className={'price-value'}>
            ₹ {getAmount(1.05 * pkg.price * pkg.quantity)}
          </h3>
        </div>
      ))}
      </>
    )
  }
    
  return (
    <div className={'ticket-cart-container'}>
      <div className={'heading'}>
        {isMobile ? (
          <h3 className={'heading-text'}>Your Booking Summary</h3>
        ) : (
          <h2 className={'heading-text'}>Your Booking Summary</h2>
        )}
        <h4 className={'edit-text'} onClick={onEditClick}>
          EDIT ORDER
        </h4>
      </div>
      {Object.values(data).map(ticketData => (
        <div key={ticketData.ticket_type_id} className={'ticket-info-container'}>
          <h3 className={'ticket-type-name'}>
            {ticketData.ticket_type} Tickets
          </h3>
          <DotSeparator />
          <h3 className={'count'}>{ticketData.selected}</h3>
          <DotSeparator />
          <h3 className={'price-value'}>
            ₹ {getAmount(ticketData.total_cost)}
          </h3>
        </div>
      ))}
      {renderSelectedFnBs()}
      <h4 className={'form-heading'}>
        Enter your details below to complete your booking
      </h4>
      <EventTicketUserForm
        className={'event-user-form'}
        cartValue={cart_value}
        tickets={{ ticketData: data, eventTimeID: eventTimeID }}
        onError={onClosePress}
        eventTitle={eventTitle}
        eventDate={eventDate}
        selectedFnBPackages={selectedFnBPackages}
        outletSeating={outletSeating}
        outlet_id={outlet_id}
      />
    </div>
  );
};
export default EventTicketCart;
